import {lockBody, unlockBody} from "../functions";

const {__} = wp.i18n
document.addEventListener('DOMContentLoaded', function (dom) {
    const jsMenu = dom.target.querySelector('.js-menu')
    const jsMenuToggle = dom.target.querySelector('.js-menu-toggle')
    const jsMenuToggleClose = dom.target.querySelector('.js-menu-toggle-close')

    if (jsMenu && jsMenuToggle && jsMenuToggleClose) {
        const jsMenuToggleIcon = jsMenuToggle.querySelector('.vn-icons')
        jsMenuToggle.addEventListener('click', function (e) {
            jsMenuToggle.classList.toggle('is-active')
            const isActive = jsMenuToggle.classList.contains('is-active')
            jsMenuToggleIcon.classList.toggle('vn-icons-menu')
            jsMenuToggleIcon.classList.toggle('vn-icons-close')
            jsMenuToggle.querySelector('.vn-a-content').innerText = isActive ? __('Close', 'vn') : __('Menu', 'vn')
            isActive ? lockBody() : unlockBody();
            jsMenu.classList.toggle('active')
        })
        jsMenuToggleClose.addEventListener('click', function (e) {
            jsMenuToggle.classList.toggle('is-active')
            const isActive = jsMenuToggle.classList.contains('is-active')
            isActive ? lockBody() : unlockBody();
            jsMenuToggleIcon.classList.toggle('vn-icons-menu')
            jsMenuToggleIcon.classList.toggle('vn-icons-close')
            jsMenuToggle.querySelector('.vn-a-content').innerText = isActive ? __('Close', 'vn') : __('Menu', 'vn')
            jsMenu.classList.toggle('active')
        })
    }
})
